const DB_NAME = 'kakushite-share-target'
const STORE = 'shared-files'
const MAX_SHARED_FILES = 8
const MAX_SHARED_BYTES = 80 * 1024 * 1024
const MAX_STORED_AGE_MS = 24 * 60 * 60 * 1000

interface StoredFile { file: File; savedAt: number }

function openDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1)
    request.onupgradeneeded = () => {
      if (!request.result.objectStoreNames.contains(STORE)) request.result.createObjectStore(STORE, { autoIncrement: true })
    }
    request.onsuccess = () => resolve(request.result)
    request.onerror = () => reject(request.error ?? new Error('共有画像の一時保存領域を開けませんでした'))
    request.onblocked = () => reject(new Error('共有画像の一時保存領域が別の画面で使用中です'))
  })
}

function isAcceptedStoredFile(value: StoredFile, cutoff: number): boolean {
  return value.file instanceof File
    && value.file.size > 0
    && value.file.size <= MAX_SHARED_BYTES
    && value.savedAt >= cutoff
    && (value.file.type.startsWith('image/') || /\.(?:jpe?g|png|webp|heic|heif)$/i.test(value.file.name))
}

export async function takeSharedFiles(): Promise<File[]> {
  if (!('indexedDB' in window)) return []
  const db = await openDb()
  try {
    return await new Promise<File[]>((resolve, reject) => {
      const tx = db.transaction(STORE, 'readwrite')
      const store = tx.objectStore(STORE)
      const request = store.getAll()
      let values: File[] = []

      request.onsuccess = () => {
        const cutoff = Date.now() - MAX_STORED_AGE_MS
        values = (request.result as StoredFile[])
          .filter((item) => isAcceptedStoredFile(item, cutoff))
          .slice(0, MAX_SHARED_FILES)
          .map((item) => item.file)
        store.clear()
      }
      request.onerror = () => reject(request.error ?? new Error('共有画像を読み出せませんでした'))
      tx.oncomplete = () => resolve(values)
      tx.onerror = () => reject(tx.error ?? new Error('共有画像の読み出し処理に失敗しました'))
      tx.onabort = () => reject(tx.error ?? new Error('共有画像の読み出し処理が中断されました'))
    })
  } finally {
    db.close()
  }
}
